import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';

import * as yup from 'yup';

/** External user create/update request body */
export interface ExternalUserFormInterface {
  job?: string;
  /** If `true` then external user will receive mailings */
  isMailingEnabled?: boolean;
  /** Client this external user belongs to */
  client: ClientFindInterface;
  /** Related counterparties (mostly need for depds) */
  contragents?: ContragentFindInterface[];
}

/** External user create/update request body - DTO schema */
export const ExternalUserFormDto = SerdeDtoClass.create<ExternalUserFormInterface>(SecurityDtoKeysEnum.EXTERNAL_USER_FORM_DTO, {
  job: {
    optional: true,
    label: 'Должность',
    serializer: yup.string(),
  },
  isMailingEnabled: {
    optional: true,
    default: false,
    label: 'Вкключать в рассылку',
    serializer: yup.boolean(),
  },
  client: {
    label: 'Клиент',
    checkers: [ClientCheckerKeysEnum.CLIENT_ASSERT_EXISTS_BY_DTO],
    serializer: entityLikeSchema,
  },
  contragents: {
    optional: true,
    label: 'Контрагенты',
    checkers: [ClientCheckerKeysEnum.CONTRAGENT_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(entityLikeSchema),
  },
});
